namespace TabAurous.Master {
    export interface CustomerCategoryRow {
        Id?: number;
        Code?: string;
        Name?: string;
        UpgradeValue?: number;
        NextLevel?: number;
    }

    export namespace CustomerCategoryRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'Master.CustomerCategory';
        export const lookupKey = 'Master.CustomerCategory';

        export function getLookup(): Q.Lookup<CustomerCategoryRow> {
            return Q.getLookup<CustomerCategoryRow>('Master.CustomerCategory');
        }
        export const deletePermission = 'HR:CustomerCategory:Delete';
        export const insertPermission = 'HR:CustomerCategory:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:CustomerCategory:Edit';

        export declare const enum Fields {
            Id = "Id",
            Code = "Code",
            Name = "Name",
            UpgradeValue = "UpgradeValue",
            NextLevel = "NextLevel"
        }
    }
}
